import { createContext } from 'react';
import { IUpdateGameDeveloper } from 'types';

export type TTypeOfEditGameDeveloperModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';
export interface IInitialFormData {
	name: string;
}

export interface IEditGameDeveloperState {
	initialFormData: IInitialFormData | null;
	developerID: string;
	name: string;
	dataForSubmit: IUpdateGameDeveloper | null;
	typeOfModalWindow: TTypeOfEditGameDeveloperModalWindow;
}

export const editGameDeveloperInitialState: IEditGameDeveloperState = {
	initialFormData: null,
	developerID: '',
	name: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditGameDeveloperContext extends IEditGameDeveloperState {
	changeName(value: string): void;
	setDataForSubmit(value: IUpdateGameDeveloper | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditGameDeveloperModalWindow | null): void;
	resetFields(): void;
}

export const EditGameDeveloperContext = createContext<IEditGameDeveloperContext>({
	changeName: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...editGameDeveloperInitialState,
});
